export function slideUp(el, time = 150) {

    el.style.height = 'auto';
    el.style.display = 'block';

    const height = el.offsetHeight;
    el.style.overflow = 'hidden';

    const currentTime = new Date().getTime();

    const timer = setInterval(function () {
        var interval = new Date().getTime() - currentTime;
        if (interval < time) {
            const percent = interval / time;
            const result = parseInt(height) - (parseInt(height) * percent);
            el.style.height = result + 'px';
        } else {
            el.style.height = 0;
            clearInterval(timer);
        }
    }, 1);
}

export function slideDown(el, time = 150) {

    el.style.height = 'auto';
    el.style.display = 'block';

    const height = window.getComputedStyle(el, null)['height'];
    el.style.height = '0px';

    el.style.display = 'block';
    el.style.overflow = 'hidden';

    const currentTime = new Date().getTime();

    const timer = setInterval(function () {
        var interval = new Date().getTime() - currentTime;
        if (interval < time) {
            const percent = interval / time;
            const result = parseInt(height) * percent;
            el.style.height = result + 'px';
        } else {
            el.style.height = height;
            clearInterval(timer);
        }
    }, 1);
}

export default {
    slideUp,
    slideDown
}
